/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * Alchemer Impersonation API
 * OpenAPI spec version: 1.0.44
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CheckImpersonateAccessResponseSchema,
  CheckImpersonationAccessImpersonateParams,
  CheckImpersonatorResponseSchema,
  CreateImpersonateAccessRequestSchema,
  CreateImpersonateAccessResponseSchema,
  ErrorAuthorizationSchema,
  ErrorInternalSchema,
  ErrorNotFoundSchema,
  ErrorRateLimitSchema,
  ErrorValidationSchema,
  GetImpersonationAccessImpersonateParams,
  HealthSchema,
  ImpersonatorRequestSchema,
  ImpersonatorResponseSchema,
  UpdateImpersonateAccessRequestSchema,
  UpdateImpersonatorRequestSchema,
} from '../schemas';

import { GlobalAxiosClient } from '../../mutators/GlobalAxiosClient';

/**
 * @summary Health
 */
export const healthImpersonation = () => {
  return GlobalAxiosClient<HealthSchema>({ url: `/impersonation/health`, method: 'GET' });
};

export const getHealthImpersonationInfiniteQueryKey = () => {
  return ['infinite', `/impersonation/health`] as const;
};

export const getHealthImpersonationQueryKey = () => {
  return [`/impersonation/health`] as const;
};

export const getHealthImpersonationInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof healthImpersonation>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthImpersonationInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthImpersonation>>> = () => healthImpersonation();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof healthImpersonation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthImpersonationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof healthImpersonation>>>;
export type HealthImpersonationInfiniteQueryError = unknown;

export function useHealthImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof healthImpersonation>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthImpersonation>>,
          TError,
          Awaited<ReturnType<typeof healthImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof healthImpersonation>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthImpersonation>>,
          TError,
          Awaited<ReturnType<typeof healthImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof healthImpersonation>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health
 */

export function useHealthImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof healthImpersonation>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthImpersonationInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getHealthImpersonationQueryOptions = <
  TData = Awaited<ReturnType<typeof healthImpersonation>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthImpersonationQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthImpersonation>>> = () => healthImpersonation();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthImpersonation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthImpersonationQueryResult = NonNullable<Awaited<ReturnType<typeof healthImpersonation>>>;
export type HealthImpersonationQueryError = unknown;

export function useHealthImpersonation<TData = Awaited<ReturnType<typeof healthImpersonation>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthImpersonation>>,
          TError,
          Awaited<ReturnType<typeof healthImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthImpersonation<TData = Awaited<ReturnType<typeof healthImpersonation>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthImpersonation>>,
          TError,
          Awaited<ReturnType<typeof healthImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthImpersonation<TData = Awaited<ReturnType<typeof healthImpersonation>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health
 */

export function useHealthImpersonation<TData = Awaited<ReturnType<typeof healthImpersonation>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof healthImpersonation>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHealthImpersonationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns whether the authenticated user is an active impersonator.
 * @summary Check if current user is an impersonator
 */
export const checkImpersonatorImpersonation = () => {
  return GlobalAxiosClient<CheckImpersonatorResponseSchema>({
    url: `/impersonation/impersonation/impersonator`,
    method: 'GET',
  });
};

export const getCheckImpersonatorImpersonationInfiniteQueryKey = () => {
  return ['infinite', `/impersonation/impersonation/impersonator`] as const;
};

export const getCheckImpersonatorImpersonationQueryKey = () => {
  return [`/impersonation/impersonation/impersonator`] as const;
};

export const getCheckImpersonatorImpersonationInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(options?: {
  query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckImpersonatorImpersonationInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>> = () =>
    checkImpersonatorImpersonation();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckImpersonatorImpersonationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkImpersonatorImpersonation>>
>;
export type CheckImpersonatorImpersonationInfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useCheckImpersonatorImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonatorImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonatorImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check if current user is an impersonator
 */

export function useCheckImpersonatorImpersonationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCheckImpersonatorImpersonationInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCheckImpersonatorImpersonationQueryOptions = <
  TData = Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckImpersonatorImpersonationQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>> = () =>
    checkImpersonatorImpersonation();

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckImpersonatorImpersonationQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkImpersonatorImpersonation>>
>;
export type CheckImpersonatorImpersonationQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useCheckImpersonatorImpersonation<
  TData = Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonatorImpersonation<
  TData = Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonatorImpersonation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonatorImpersonation<
  TData = Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check if current user is an impersonator
 */

export function useCheckImpersonatorImpersonation<
  TData = Awaited<ReturnType<typeof checkImpersonatorImpersonation>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonatorImpersonation>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCheckImpersonatorImpersonationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create Impersonator
 */
export const createImpersonatorImpersonation = (impersonatorRequestSchema: ImpersonatorRequestSchema) => {
  return GlobalAxiosClient<ImpersonatorResponseSchema>({
    url: `/impersonation/impersonation/impersonator`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: impersonatorRequestSchema,
  });
};

export const getCreateImpersonatorImpersonationMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createImpersonatorImpersonation>>,
    TError,
    { data: ImpersonatorRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createImpersonatorImpersonation>>,
  TError,
  { data: ImpersonatorRequestSchema },
  TContext
> => {
  const mutationKey = ['createImpersonatorImpersonation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createImpersonatorImpersonation>>,
    { data: ImpersonatorRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return createImpersonatorImpersonation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateImpersonatorImpersonationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createImpersonatorImpersonation>>
>;
export type CreateImpersonatorImpersonationMutationBody = ImpersonatorRequestSchema;
export type CreateImpersonatorImpersonationMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Create Impersonator
 */
export const useCreateImpersonatorImpersonation = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createImpersonatorImpersonation>>,
      TError,
      { data: ImpersonatorRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createImpersonatorImpersonation>>,
  TError,
  { data: ImpersonatorRequestSchema },
  TContext
> => {
  return useMutation(getCreateImpersonatorImpersonationMutationOptions(options), queryClient);
};

/**
 * Grant access to support impersonators for a given period of time. Maximum durationDays of 30 (should be configurable).
 * @summary Grant impersonation access
 */
export const grantImpersonationAccessImpersonate = (
  createImpersonateAccessRequestSchema: CreateImpersonateAccessRequestSchema,
) => {
  return GlobalAxiosClient<CreateImpersonateAccessResponseSchema>({
    url: `/impersonation/impersonation/impersonate-access`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createImpersonateAccessRequestSchema,
  });
};

export const getGrantImpersonationAccessImpersonateMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantImpersonationAccessImpersonate>>,
    TError,
    { data: CreateImpersonateAccessRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantImpersonationAccessImpersonate>>,
  TError,
  { data: CreateImpersonateAccessRequestSchema },
  TContext
> => {
  const mutationKey = ['grantImpersonationAccessImpersonate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantImpersonationAccessImpersonate>>,
    { data: CreateImpersonateAccessRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return grantImpersonationAccessImpersonate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantImpersonationAccessImpersonateMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantImpersonationAccessImpersonate>>
>;
export type GrantImpersonationAccessImpersonateMutationBody = CreateImpersonateAccessRequestSchema;
export type GrantImpersonationAccessImpersonateMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Grant impersonation access
 */
export const useGrantImpersonationAccessImpersonate = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantImpersonationAccessImpersonate>>,
      TError,
      { data: CreateImpersonateAccessRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof grantImpersonationAccessImpersonate>>,
  TError,
  { data: CreateImpersonateAccessRequestSchema },
  TContext
> => {
  return useMutation(getGrantImpersonationAccessImpersonateMutationOptions(options), queryClient);
};

/**
 * Update impersonation access for a specific combination of email/app/datacenter. Creates new impersonation access if the impersonation access record does not exist.
 * @summary Update impersonation access
 */
export const updateImpersonationAccessImpersonate = (
  updateImpersonateAccessRequestSchema: UpdateImpersonateAccessRequestSchema,
) => {
  return GlobalAxiosClient<CreateImpersonateAccessResponseSchema>({
    url: `/impersonation/impersonation/impersonate-access`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateImpersonateAccessRequestSchema,
  });
};

export const getUpdateImpersonationAccessImpersonateMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateImpersonationAccessImpersonate>>,
    TError,
    { data: UpdateImpersonateAccessRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateImpersonationAccessImpersonate>>,
  TError,
  { data: UpdateImpersonateAccessRequestSchema },
  TContext
> => {
  const mutationKey = ['updateImpersonationAccessImpersonate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateImpersonationAccessImpersonate>>,
    { data: UpdateImpersonateAccessRequestSchema }
  > = (props) => {
    const { data } = props ?? {};

    return updateImpersonationAccessImpersonate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateImpersonationAccessImpersonateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateImpersonationAccessImpersonate>>
>;
export type UpdateImpersonationAccessImpersonateMutationBody = UpdateImpersonateAccessRequestSchema;
export type UpdateImpersonationAccessImpersonateMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update impersonation access
 */
export const useUpdateImpersonationAccessImpersonate = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateImpersonationAccessImpersonate>>,
      TError,
      { data: UpdateImpersonateAccessRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateImpersonationAccessImpersonate>>,
  TError,
  { data: UpdateImpersonateAccessRequestSchema },
  TContext
> => {
  return useMutation(getUpdateImpersonationAccessImpersonateMutationOptions(options), queryClient);
};

/**
 * Retrieve the impersonation access record for the authenticated user.
 * @summary Get impersonation access for current user
 */
export const getImpersonationAccessImpersonate = (params: GetImpersonationAccessImpersonateParams) => {
  return GlobalAxiosClient<CreateImpersonateAccessResponseSchema>({
    url: `/impersonation/impersonation/impersonate-access`,
    method: 'GET',
    params,
  });
};

export const getGetImpersonationAccessImpersonateInfiniteQueryKey = (
  params?: GetImpersonationAccessImpersonateParams,
) => {
  return ['infinite', `/impersonation/impersonation/impersonate-access`, ...(params ? [params] : [])] as const;
};

export const getGetImpersonationAccessImpersonateQueryKey = (params?: GetImpersonationAccessImpersonateParams) => {
  return [`/impersonation/impersonation/impersonate-access`, ...(params ? [params] : [])] as const;
};

export const getGetImpersonationAccessImpersonateInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImpersonationAccessImpersonateInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>> = () =>
    getImpersonationAccessImpersonate(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetImpersonationAccessImpersonateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>
>;
export type GetImpersonationAccessImpersonateInfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get impersonation access for current user
 */

export function useGetImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetImpersonationAccessImpersonateInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetImpersonationAccessImpersonateQueryOptions = <
  TData = Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetImpersonationAccessImpersonateQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>> = () =>
    getImpersonationAccessImpersonate(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetImpersonationAccessImpersonateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>
>;
export type GetImpersonationAccessImpersonateQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useGetImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get impersonation access for current user
 */

export function useGetImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: GetImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getImpersonationAccessImpersonate>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetImpersonationAccessImpersonateQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Check whether a user has an active impersonate access. If requester is an active Impersonator, the response will indicate whether the target user has granted impersonation access.
 * @summary Check impersonation access
 */
export const checkImpersonationAccessImpersonate = (params: CheckImpersonationAccessImpersonateParams) => {
  return GlobalAxiosClient<CheckImpersonateAccessResponseSchema>({
    url: `/impersonation/impersonation/check-impersonate-access`,
    method: 'GET',
    params,
  });
};

export const getCheckImpersonationAccessImpersonateInfiniteQueryKey = (
  params?: CheckImpersonationAccessImpersonateParams,
) => {
  return ['infinite', `/impersonation/impersonation/check-impersonate-access`, ...(params ? [params] : [])] as const;
};

export const getCheckImpersonationAccessImpersonateQueryKey = (params?: CheckImpersonationAccessImpersonateParams) => {
  return [`/impersonation/impersonation/check-impersonate-access`, ...(params ? [params] : [])] as const;
};

export const getCheckImpersonationAccessImpersonateInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckImpersonationAccessImpersonateInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>> = () =>
    checkImpersonationAccessImpersonate(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckImpersonationAccessImpersonateInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>
>;
export type CheckImpersonationAccessImpersonateInfiniteQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useCheckImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check impersonation access
 */

export function useCheckImpersonationAccessImpersonateInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCheckImpersonationAccessImpersonateInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCheckImpersonationAccessImpersonateQueryOptions = <
  TData = Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckImpersonationAccessImpersonateQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>> = () =>
    checkImpersonationAccessImpersonate(params);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckImpersonationAccessImpersonateQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>
>;
export type CheckImpersonationAccessImpersonateQueryError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

export function useCheckImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
          TError,
          Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Check impersonation access
 */

export function useCheckImpersonationAccessImpersonate<
  TData = Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>,
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
>(
  params: CheckImpersonationAccessImpersonateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof checkImpersonationAccessImpersonate>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCheckImpersonationAccessImpersonateQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create or update a super-admin impersonator. This user will have the ability to impersonate customers who have explicitly granted access. This endpoint handles enable/disable operations to maintain audit logs of impersonation sessions.
 * @summary Update impersonator status
 */
export const updateImpersonatorImpersonationEmail = (
  email: string,
  updateImpersonatorRequestSchema: UpdateImpersonatorRequestSchema,
) => {
  return GlobalAxiosClient<ImpersonatorResponseSchema>({
    url: `/impersonation/impersonation/impersonator/${email}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateImpersonatorRequestSchema,
  });
};

export const getUpdateImpersonatorImpersonationEmailMutationOptions = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateImpersonatorImpersonationEmail>>,
    TError,
    { email: string; data: UpdateImpersonatorRequestSchema },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateImpersonatorImpersonationEmail>>,
  TError,
  { email: string; data: UpdateImpersonatorRequestSchema },
  TContext
> => {
  const mutationKey = ['updateImpersonatorImpersonationEmail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateImpersonatorImpersonationEmail>>,
    { email: string; data: UpdateImpersonatorRequestSchema }
  > = (props) => {
    const { email, data } = props ?? {};

    return updateImpersonatorImpersonationEmail(email, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateImpersonatorImpersonationEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateImpersonatorImpersonationEmail>>
>;
export type UpdateImpersonatorImpersonationEmailMutationBody = UpdateImpersonatorRequestSchema;
export type UpdateImpersonatorImpersonationEmailMutationError =
  | ErrorAuthorizationSchema
  | ErrorNotFoundSchema
  | ErrorValidationSchema
  | ErrorRateLimitSchema
  | ErrorInternalSchema;

/**
 * @summary Update impersonator status
 */
export const useUpdateImpersonatorImpersonationEmail = <
  TError =
    | ErrorAuthorizationSchema
    | ErrorNotFoundSchema
    | ErrorValidationSchema
    | ErrorRateLimitSchema
    | ErrorInternalSchema,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateImpersonatorImpersonationEmail>>,
      TError,
      { email: string; data: UpdateImpersonatorRequestSchema },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateImpersonatorImpersonationEmail>>,
  TError,
  { email: string; data: UpdateImpersonatorRequestSchema },
  TContext
> => {
  return useMutation(getUpdateImpersonatorImpersonationEmailMutationOptions(options), queryClient);
};
